/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BoardItem/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import IconAndTitle from './IconAndTitle/index'
import IconOnly from './IconOnly/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function BoardItem({
  children,
  viewPath = "/DesignSystem/TasksBoardsList/Boards/Content/Boards/Content/BoardItem"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let boardIconOnlyValueData = fromData.useDataFormat({ viewPath,
context: 'board',
path: 'iconOnly',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: boardIconOnlyValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'IconAndTitle'}>
<IconAndTitle
  viewPath={`${viewPath}/IconAndTitle`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'IconOnly'}>
<IconOnly
  viewPath={`${viewPath}/IconOnly`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}